module.exports = __webpack_public_path__ + "static/media/banner-1.533d0435.jpg";